import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {
  CommonUtility, ServerConstantsService, DataService, SINGLE_ROW_HEADER, ComponentSummary,
  Components, DateUtility, AgGridUtility, AUDIT_BTN, AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE,
  AUDIT_ENTITY_COLUMN_DEFS, AUDIT_PAGE_TITLE, Task, WpPerson, WpReferral, EmploymentPlan, EmploymentPlanSummary
} from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import { GridOptions } from 'ag-grid';
import * as CryptoJS from 'crypto-js';
import { HttpEventType,HttpResponse,HttpRequest } from '@angular/common/http';
import { GridviewComponent } from '../gridview/gridview.component';
import { ProgressbarComponent } from '../progressbar/progressbar.component';
import { DeleteComponent } from '../delete/delete.component';
import {InputrendererComponent} from '../inputrenderer/inputrenderer.component';

@Component({
  selector: 'app-comparable-workfare',
  templateUrl: './comparable-workfare.component.html',
  styleUrls: ['./comparable-workfare.component.scss']
})
export class ComparableWorkfareComponent implements OnInit {
  serverConstants:any;
  fileToUpload: File = null;
  filestoUpload=[];
  addNew:Boolean = false;
  private gridApi;
  private gridColumnApi;
  private summarygridApi;
  private summarygridColumnApi;
  public context;
  private workfare={
    name:null,
    desc:null,
    address:null,
    month:null,
    supPhn:null,
    supMail:null,
    supName:null,
    orgFax:null,
    orgMailing:null,
    orgPhn:null,
    repHours:null,
    activity:null,
    id:null,
    workfare_id:null,
    path:[],
    perId:null,
    fin_sw:null
  }
  monthDropdown:any=[];
  reportedHours:any;
  reportedMins:any;
  activityReason:any;
  error:Boolean = true;
  selectedMonth:any;
  viewOnly:Boolean = false;
  readOnly:Boolean = false;
  assignedHours:Number;
  monthError:Boolean = false;
  hoursArray = new Array();
  public frameworkComponents;
  public uploadframeworkComponents;
  defaultColDef = { resizable: true, cellStyle:{'font-size':'14px'} };
  columnDefs = [
    {headerName: 'Organization Name', field: 'org_name' },
    {headerName: 'Month', field: 'month' },
    {headerName: 'Reported Hours', field: 'reported_hours'},
    {headerName: 'Verified Hours', field: 'verified_hours', cellRenderer:'hoursEditor'},
    {headerName: 'Action', field: 'id',cellRenderer:'viewrenderer'}
];
uploadcolumnDefs =[
  {headerName: 'File Name', field: 'originalname' },
  {headerName: 'Date', field: 'date' },
  {headerName: 'Size', field: 'size' },
  {headerName: 'Progress', field: 'progress',cellRenderer:'progressrenderer' },
  {headerName: 'Action', field: 'path',cellRenderer:'viewrenderer'}
];
uploadData =[];

rowData = [];
alerts:any=[];
alertsClone:any=[];

  constructor(private route: Router,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    public dataService: DataService,
    private toastService: NotificationsService,
    private serverConstantsService: ServerConstantsService) {
      this.serverConstants = serverConstantsService.getConstants();
      if (this.dataService.getSharedDataObject().get('COMPS') === undefined) {
        this.router.navigate(['/task']);
      }
     }

     ngOnInit() {
      this.dataService.globalAccess = false;
      let index = this.dataService.getSharedDataObject().get("COMPS").innerNavPages.find(x=> x.pageId === 'COMWF');
    if(index.readOnly == true){
      this.readOnly = true;
    }
      let sharedData = this.dataService.getSharedDataObject();
      if (sharedData.get('wpPersonId') !== null && sharedData.get('wpPersonId') !== undefined) {
        this.workfare.perId = Number(sharedData.get('wpPersonId'));
      }
      //this.workfare.perId = this.loginService.personId;
      for(let i=0; i<81; i++){
        this.hoursArray.push(i);
      }
      this.context = {
        componentParent:this
      };
      this.frameworkComponents = {
        viewrenderer: GridviewComponent,
        hoursEditor: InputrendererComponent
      };
      this.uploadframeworkComponents = {
        viewrenderer: DeleteComponent,
        progressrenderer:ProgressbarComponent
      };
      let monthName = new Array("January","February","March","April","May","June","July","August","September","October","November","December");
      let d = new Date();
      for(let i=0;i<=24;i++){
        this.monthDropdown.push(monthName[d.getMonth()]+'-'+d.getFullYear());
        d.setMonth(d.getMonth()-1);
      }
      this.selectedMonth = this.monthDropdown[0];
      this.loadSummary();
      //this.assignedHours = Math.floor(this.loginService.monthlyBenefit/this.loginService.maxWage);
    }
    onsummaryGridReady(params){
      this.summarygridApi = params.api;
      this.summarygridColumnApi = params.columnApi;
      this.summarygridApi.sizeColumnsToFit();
      //this.summarygridApi.setDomLayout("autoHeight");
    }
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();
      //this.gridApi.setDomLayout("autoHeight");
    }
    newWorkfare(){
      this.addNew = true;
      this.workfare = {
        name:null,
        desc:null,
        address:null,
        month:null,
        supPhn:null,
        supMail:null,
        supName:null,
        orgFax:null,
        orgMailing:null,
        orgPhn:null,
        repHours:null,
        activity:null,
        id:null,
        workfare_id:null,
        path:[],
        perId:null,
        fin_sw:null
      };
      let sharedData = this.dataService.getSharedDataObject();
      if (sharedData.get('wpPersonId') !== null && sharedData.get('wpPersonId') !== undefined) {
        this.workfare.perId = Number(sharedData.get('wpPersonId'));
      }
      this.fileToUpload = null;
      this.filestoUpload=[];
      this.reportedHours = null;
  this.reportedMins = null;
  this.activityReason = null;
  this.uploadData =[];

    }
    validate(){
      if(this.workfare.month != null || this.workfare.month != undefined){
        if(parseInt(this.workfare.month.substring(0, 2)) > 12){
          this.workfare.month = null;
          this.error = false;
        }
        else if(parseInt(this.workfare.month.substring(0, 2)) > (new Date().getMonth()+1) && (parseInt(this.workfare.month.substring(2, 6)) >= new Date().getFullYear())){
          this.workfare.month = null;
          this.error = false;
          }
          else if(parseInt(this.workfare.month.substring(0, 2)) <= (new Date().getMonth()+1) && (parseInt(this.workfare.month.substring(2, 6)) > new Date().getFullYear())){
            this.workfare.month = null;
            this.error = false;
            }  
        /*else{
          let request = {
            month:this.workfare.month.substring(0,2)+ '/'+ this.workfare.month.substring(2,6),
            perId: this.workfare.perId
          }
          this.http.post(this.serverConstants.CITIZEN_API_URL + '/workfare/load',
      request).subscribe((data)=>{
            let result = CryptoJS.AES.decrypt(data["result"],"workfare").toString(CryptoJS.enc.Utf8);
            let convResult = JSON.parse(result);
            if(convResult.length > 0){
              if(convResult[0].fin_sw == 'Y'){
                this.monthError = true;
                this.workfare.month = null;
              }
              else{
                this.monthError = false;
              }
            }
            else{
              this.monthError = false;
            }
          },error=>{
            this.toastService.error("Unable to validate workfare","Comparable workfare");
          })
        }*/
      }
    }
    handleFileInput(files: FileList) {
      this.fileToUpload = files.item(0);
      let blob = this.fileToUpload;
      let fileReader = new FileReader();
      fileReader.onloadend = function(e:any) {
        //const that = params.context.component;
        var arr = (new Uint8Array(<ArrayBuffer> e.target.result)).subarray(0, 4);
        var header = "";
        for(var i = 0; i < arr.length; i++) {
           header += arr[i].toString(16);
        };

        if(['FFD8','8950','2550','D0CF'].indexOf(header.substring(0,4)) > -1){
          localStorage.setItem('fileValidationCW','true');
        }
        else{
          localStorage.setItem('fileValidationCW','false');
        }
      };
      fileReader.readAsArrayBuffer(blob);
      setTimeout(()=>{
        if(((this.fileToUpload.size/1024)/1024) > 5){
          this.toastService.error("File size exceeds maximum limit","Comparable Workfare");
        }
        else if(localStorage.getItem('fileValidationCW') === 'true'){
          this.filestoUpload.push(this.fileToUpload);
          let file={
            originalname:this.fileToUpload.name,
            date:(new Date().getMonth()+1) + '/'+new Date().getDate() + '/' + new Date().getFullYear(),
            size:((this.fileToUpload.size/1024)/1024).toFixed(2)+'MB',
            progress:0,
            path:"upload"
          }
          this.uploadData.push(file);
          this.gridApi.setRowData(this.uploadData);
        }
        else{
          this.toastService.error("File type is not supported to upload","Comparable Workfare");
        }
      },1000);
      
  }
  upload(){
    let formData = new FormData();
    if(this.filestoUpload.length == 0){
      this.toastService.error("No files selected to upload", "Comparable Workfare");
    }
    else{
      for(let i =0; i < this.filestoUpload.length; i++){
        formData.append("files", this.filestoUpload[i], this.filestoUpload[i]['name']);
      }
      const req = new HttpRequest('POST', this.serverConstants.CITIZEN_API_URL+ '/fileUpload', formData, {
        reportProgress: true,
      });
      this.http.request(req).subscribe(event => {
        // Via this API, you get access to the raw event stream.
        // Look for upload progress events.
        if (event.type === HttpEventType.UploadProgress) {
          // This is an upload progress event. Compute and show the % done:
          const percentDone = Math.round(100 * event.loaded / event.total);
          this.uploadData.forEach((element)=>{
            element.progress = percentDone;
          })
          this.gridApi.setRowData(this.uploadData);
        } else if (event instanceof HttpResponse) {
          this.filestoUpload = [];
          event.body["data"].forEach((element)=>{
            this.uploadData.forEach((element2)=>{
              if((element.originalname == element2.originalname)&& (element2.size == (((element.size/1024)/1024).toFixed(2)+'MB'))){
                element2.path = element.filename;
              }
            })
          })
          this.workfare.path.forEach((element)=>{
            delete element.destination;
            delete element.encoding;
            delete element.fieldname;
            delete element.mimetype;
            element.date = (new Date().getMonth()+1) + '/'+new Date().getDate() + '/' + new Date().getFullYear();
          });
          this.gridApi.setRowData(this.uploadData);
          this.workfare.path = this.uploadData;
          this.saveDocument();
          this.toastService.success("Succesfully uploaded file","Comparable Workfare");
        }
      },error=>{
        this.toastService.error("Unable to upload file", "Comparable Workfare");
      });
    }
    
    /*this.loginService.fileUpload(formData).subscribe((event)=>{
      console.log(event);
      if (event['type'] === HttpEventType.UploadProgress) {
        // This is an upload progress event. Compute and show the % done:
        const percentDone = Math.round(100 * event['loaded'] / event['total']);
        console.log(`File is ${percentDone}% uploaded.`);
      } else if (event instanceof HttpResponse) {
        console.log('File is completely uploaded!');
      }
      /*if(data["status"] == 200){
        this.filestoUpload = [];
        this.uploadData.forEach((element)=>{
          element.progress = 100;
        })
        this.gridApi.setRowData(this.uploadData);
        this.toastService.success("Succesfully uploaded file","Comparable Workfare")
      }
      else{
        this.toastService.error("Unable to upload file", "Comparable Workfare");
      }
    },error=>{
      this.toastService.error("Unable to upload file", "Comparable Workfare");
    })*/
  }
  save(){
    this.workfare.repHours = parseFloat(this.reportedHours+'.'+this.reportedMins).toFixed(2);
    this.workfare.activity = this.activityReason;
    this.workfare.fin_sw = 'Y';
    if(this.filestoUpload.length > 0){
      this.upload();
    }
    console.log(this.workfare);
    let request = {
      details:CryptoJS.AES.encrypt(JSON.stringify(this.workfare),"workfare").toString()
    }
     this.http.post(this.serverConstants.CITIZEN_API_URL + '/workfare/save',
      request).subscribe((data)=>{
      if(data["message"]== "success"){
        this.toastService.success("Successfully saved workfare","Comparable workfare");
        this.addNew = false;
        this.loadSummary();
      }
      else{
        this.toastService.error("Unable to save workfare","Comparable workfare");
      }
    },error=>{
      this.toastService.error("Unable to save workfare","Comparable workfare");
    })
  }
  clickEvent(event){
    if(event.column.colDef.headerName == 'Action' && event.data.defaultAction == 'delete' && event.data.path == 'upload'){
      this.uploadData.splice(event.node.rowIndex,1);
      this.gridApi.setRowData(this.uploadData);
      this.filestoUpload = this.filestoUpload.filter(function( obj ) {
        return ((obj.name !== event.data.name) && (((obj.size/1024)/1024).toFixed(2)+'MB' != event.data.size));
      });
    }
    else if(event.column.colDef.headerName == 'Action' && event.data.defaultAction == 'delete'){
      this.uploadData.splice(event.node.rowIndex,1);
      this.gridApi.setRowData(this.uploadData);
      this.workfare.path = this.workfare.path.filter(function( obj ) {
        return ((obj.originalname != event.data.originalname) && (obj.size != event.data.size));
      });
    }
  }
  loadSummary(){
    let monthName = new Array("January","February","March","April","May","June","July","August","September","October","November","December");
    let splitValue = this.selectedMonth.split('-');
    let request = {
      month:(monthName.indexOf(splitValue[0])+1) +'/'+ splitValue[1],
      perId: this.workfare.perId
    }
    if(request.month.length == 6){
      request.month = 0+request.month;
    }
    console.log(request);
    this.http.post(this.serverConstants.CITIZEN_API_URL + '/workfare/load',
      request).subscribe((data)=>{
      let result = CryptoJS.AES.decrypt(data["result"],"workfare").toString(CryptoJS.enc.Utf8);
      let convResult = JSON.parse(result);
      let loadResult = [];
      convResult.forEach((element)=>{
        let req = {
          id:element['id'],
          hours:element['verfied_hours']
        }
        this.alertsClone.push(req);
        if(element.fin_sw == 'Y'){
          loadResult.push(element);
        }
      })
      this.rowData = loadResult;
      this.addNew = false;
      
    },error=>{
      this.toastService.error("Unable to load workfare","Comparable workfare");
    })
  }
  summaryclickEvent(event){
    if(event.column.colDef.headerName == 'Action' && event.data.defaultAction == 'view'){
      this.addNew = true;
      this.http.get(this.serverConstants.CITIZEN_API_URL + '/workfare/load/' + event.data.id).subscribe((data)=>{
        let result = CryptoJS.AES.decrypt(data["result"],"workfare").toString(CryptoJS.enc.Utf8);
        let convResult = JSON.parse(result);
        this.workfare.name = convResult.org_name;
        this.workfare.desc = convResult.org_desc;
        this.workfare.address = convResult.org_st_address;
        this.workfare.month = convResult.month;
        this.workfare.supPhn = convResult.sup_contact;
        this.workfare.supMail = convResult.sup_email;
        this.workfare.supName = convResult.sup_name;
        this.workfare.orgFax = convResult.org_fax;
        this.workfare.orgMailing = convResult.org_mailing;
        this.workfare.orgPhn = convResult.org_contact;
        this.activityReason = convResult.activity;
        this.workfare.id = convResult.id;
        this.workfare.workfare_id = convResult.workfare_id;
        this.uploadData = JSON.parse(convResult.path);
        this.uploadData.forEach((element)=>{
          if(!isNaN(element.size)){
            element.size = ((element.size/1024)/1024).toFixed(2)+"MB";
          }
          element.progress = 100;
          element.switch = convResult.fin_sw;
        });
        this.workfare.path = this.uploadData;
        convResult.reported_hours = parseFloat(convResult.reported_hours).toFixed(2);
        this.reportedHours = convResult.reported_hours.toString().split('.')[0];
        this.reportedMins = convResult.reported_hours.toString().split('.')[1];
      },error=>{
        this.toastService.error("Unable to load workfare","Comparable workfare");
      })
    }
  }
  finalize(){
    console.log(this.rowData);
    this.rowData.forEach((element)=>{
      if(this.dataService.getSharedDataObject().get('firstName') != undefined && this.dataService.getSharedDataObject().get('firstName') != null){
        element.lastModified = this.dataService.getSharedDataObject().get('firstName') + this.dataService.getSharedDataObject().get('lastName');
      }
      if (this.dataService.getSharedDataObject().get('wpPersonId') !== null && this.dataService.getSharedDataObject().get('wpPersonId') !== undefined) {
        element.perId = Number(this.dataService.getSharedDataObject().get('wpPersonId'));
      }
      this.alertsClone.forEach((alrt)=>{
        if((alrt.id == element['id']) && (element.verfied_hours != alrt.hours) && ((element.verfied_hours != null) && parseFloat(element.verfied_hours) < element.reported_hours)){
          this.alerts.push(element);
        }
      })
    });
    this.http.post(this.serverConstants.CITIZEN_API_URL + '/workfare/saveHours',this.rowData).subscribe((data)=>{
      if(data["message"] == 'success'){
        this.toastService.success("Successfully Updated Hours","Comparable workfare");
        this.createAlert();
      }
      else{
        this.toastService.error("Unable to Save workfare","Comparable workfare");
      }
    },error=>{
      this.toastService.error("Unable to Save workfare","Comparable workfare");
    })
  }
    /*let monthName = new Array("January","February","March","April","May","June","July","August","September","October","November","December");
    let splitValue = this.selectedMonth.split('-');
    let request = {
      month:(monthName.indexOf(splitValue[0])+1) +'/'+ splitValue[1],
      perId: this.workfare.perId
    }
    if(request.month.length == 6){
      request.month = 0+request.month;
    }
    this.loginService.finalize(request).subscribe((data)=>{
      if(data["message"]=='success'){
        this.toastService.success("Successfully finalized your hours","Comparable workfare");
        this.viewOnly = true;
        this.rowData.forEach((element)=>{
          element.fin_sw = 'Y';
        })
      }
      else{
        this.toastService.error("Unable to finalize workfare","Comparable workfare");
      }
    },error=>{
      this.toastService.error("Unable to finalize workfare","Comparable workfare");
    })
  }*/
  saveDocument(){
    this.uploadData.forEach((element)=>{
      let request = {
        name:element.originalname,
        uploaded_dt:element.date,
        size:element.size,
        progress:element.progress,
        doc_type:'Comparable Workfare',
        uploaded_by:sessionStorage.getItem("FirstName"),
        person_id:this.workfare.perId,
        path:element.path
      }
      this.http.post(this.serverConstants.CITIZEN_API_URL + '/documents/save',
      request).subscribe((data)=>{
        if(data["message"] == 'success'){
          console.log("Success");
        }
        else{
          console.log("Failure");
        }
      },error=>{
        console.log("Failure");
      })
    });
  }
  createAlert(){
    let requestArray = [];
    console.log(this.alerts);
    console.log(this.alertsClone);
    this.alerts.forEach((element)=>{
      let request = {
        createdBy: sessionStorage.getItem("FirstName"),
        description:"Comparable Workfare hours has been denied for Organization " + element['org_name'] + " for month "+ this.selectedMonth,
        personId:this.workfare.perId
      }
      requestArray.push(request);
    });
    if(requestArray.length > 0){
      this.http.post(this.serverConstants.CITIZEN_API_URL+"/alerts/save",requestArray).subscribe((data)=>{
        if(data["message"]=="success"){
          this.toastService.success('Comparable Workfare', "Alert Created for Citizen");
        }
        else{
          this.toastService.error('Comparable Workfare', "Unable to create alert for citizen");
        }
      },error=>{
        this.toastService.error('Comparable Workfare', "Unable to create alert for citizen");
      })
    }
  }
  }



// WEBPACK FOOTER //
// ./src/app/comparable-workfare/comparable-workfare.component.ts